<script lang="ts">
  // libs
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import { pluralize } from "@shared/svelte/Modules/pluralize";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import InvoiceTotalTable from "@retailer/svelte/Payments/PaymentDetails/InvoiceTotalTable.svelte";
  import ProductTable from "@retailer/svelte/Payments/PaymentDetails/ProductTable.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { Invoice } from "@shared/types/Invoice";

  // props
  export let invoice: Invoice;

  // data
  const lineItemsCount = invoice.line_items ? invoice.line_items.length : 0;
  const orderPlacedOnProvi =
    invoice.entry_source == "provi" ||
    invoice.line_items?.every(line_item => line_item.entry_source == "provi");
</script>

<div
  class="fizz-inset-square-24 fizz-space-between-8 fizz-flex-row-8-responsive fizz-border-bottom"
>
  <p>
    <strong>Invoice Summary</strong>
    {#if lineItemsCount}({pluralize("Item", lineItemsCount, true)}){/if}
  </p>
  <div
    class:fizz-flex-row-32-responsive={$LayoutStore.isDesktop}
    class:fizz-flex-row-8-responsive={$LayoutStore.isMobile}
  >
    {#if invoice.invoice_source_url}
      <a
        href="api/retailer/invoices/{invoice.external_id}/source"
        type="application/pdf"
        rel="noreferrer"
        target="_blank"
        ><div class="fizz-flex-row-4">
          <p>View Printed Invoice</p>
          <Icon height="16" width="16" type="OpenExternalLink" />
        </div></a
      >
    {/if}
    {#if invoice.order && orderPlacedOnProvi}
      <UIRouterLink stateName="layout.order_details" params={{ orderId: invoice.order.id }}>
        <a id="view-provi-order"> View Provi Order </a>
      </UIRouterLink>
    {:else}
      <p>Order placed outside of Provi</p>
    {/if}
  </div>
</div>

<div
  class="fizz-flex-row-responsive fizz-space-between fizz-text-medium fizz-align-content-start fizz-inset-squish-24"
>
  <p>
    <strong>Invoice Number:</strong><br />
    {"#" + invoice.invoice_reference_id}
  </p>
  <p>
    <strong>Ordered by:</strong><br />
    {invoice.retailer.name}<br />
    {invoice.retailer.address1}{#if invoice.retailer.address2},{/if}
    {invoice.retailer.address2 || ""}
  </p>
  <p class="fizz-hide-on-large">
    <strong>Invoice issued:</strong><br />
    {convertToDistributorDate(invoice.issue_date)}
  </p>
  <p class="fizz-hide-on-small fizz-text-right">
    <strong>Invoice issued:</strong><br />
    {convertToDistributorDate(invoice.issue_date)}
  </p>
</div>
<div class="fizz-inset-square-24 fizz-full-width fizz-surface-blue fizz-hide-on-large">
  <p class="fizz-text-strong">Invoice Details</p>
</div>

<ProductTable {invoice} />
<InvoiceTotalTable {invoice} />
